"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "UserProfileModerationContainer", {
  enumerable: true,
  get: function get() {
    return _UserProfileModerationContainer.default;
  }
});
Object.defineProperty(exports, "UserProfileModerationPanelBody", {
  enumerable: true,
  get: function get() {
    return _UserProfileModerationPanel.UserProfileModerationPanelBody;
  }
});
Object.defineProperty(exports, "UserProfileModerationPanelHeader", {
  enumerable: true,
  get: function get() {
    return _UserProfileModerationPanel.UserProfileModerationPanelHeader;
  }
});
exports.default = void 0;

var _UserProfileModerationContainer = _interopRequireDefault(require("./UserProfileModerationContainer"));

var _UserProfileModerationPanel = require("./UserProfileModerationPanel");

var _default = _UserProfileModerationContainer.default;
exports.default = _default;